import React, { useMemo, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import { useSelector } from 'react-redux';

import NewFTUXForSearch from '../../../../../Dashboard/components/NewFTUXForSearch';
import CheckTick from '../../../../../Icons/icons/CheckTick';
import { useCampaignDetail } from '../CampaignDetailProvider';

const CampaignTypeSelect = () => {
  const [campaignSearchFilter, setCampaignSearchFilter] = useState('');
  const { allCampaigns } = useSelector((state) => state.campaigns);
  const { selectedCampaigns, setSelectedCampaigns } = useCampaignDetail();

  const filteredCampaigns = useMemo(() => {
    return allCampaigns.filter((campaign) => campaign.name.match(new RegExp(campaignSearchFilter, 'i')));
  }, [allCampaigns, campaignSearchFilter]);

  const handleCampaignSelect = (campaign) => {
    const isSelected = selectedCampaigns.find((c) => c._id === campaign._id);
    if (isSelected) {
      setSelectedCampaigns(selectedCampaigns.filter((c) => c._id !== campaign._id));
    } else {
      setSelectedCampaigns([...selectedCampaigns, campaign]);
    }
  };

  return (
    <div className="filter-select-container">
      <TextField
        size="small"
        value={campaignSearchFilter}
        onChange={(e) => setCampaignSearchFilter(e.target.value)}
        placeholder="Search here"
        sx={{ width: '100%' }}
        InputProps={{
          style: {
            paddingLeft: '8px',
            borderRadius: '4px',
            marginTop: '5px',
            marginBottom: '8px',
          },
          className: 'filter-search',
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon style={{ width: '18px' }} />
            </InputAdornment>
          ),
        }}
      />
      <div className="filter-pill__options-container">
        {filteredCampaigns.length > 0 ? (
          filteredCampaigns.map((campaign) => {
            const isSelected = selectedCampaigns.find((c) => c._id === campaign._id);
            return (
              <div
                key={campaign._id}
                className={`filter-pill__option-item ${isSelected ? 'selected' : ''}`}
                onClick={() => handleCampaignSelect(campaign)}>
                <span className="filter-pill__option-item__text">{campaign.name}</span>
                {isSelected && <CheckTick color="var(--purple-p-400)" />}
              </div>
            );
          })
        ) : (
          <NewFTUXForSearch text="No Campaigns Found!" />
        )}
      </div>
    </div>
  );
};

export default CampaignTypeSelect;
